<div class="container">
  <div class="table newss">
    <div class="table-header table-header-hide-on-mobile">
      @for (itemHeader of headerSource; track itemHeader) {
        @switch (itemHeader.type) {
          @case (EnumColumnType.BUTTON) {
            <ng-container *ngTemplateOutlet="HeaderButton; context: { $implicit: itemHeader }"></ng-container>
          }
          @case (EnumColumnType.BUTTONS) {
            <ng-container
              *ngTemplateOutlet="HeaderButton; context: { $implicit: itemHeader, cssClass: 'table-header-buttons' }"
            ></ng-container>
          }
          @default {
            <p class="table-header-data" [style]="itemHeader.cssStyle">
              {{ itemHeader.translate ? (itemHeader.title | cxTranslate) : itemHeader.title }}
            </p>
          }
        }
      }
    </div>

    @if (!showLoader) {
      @switch (override) {
        @case ('PriceAgreementHistoryRows') {
          <ng-container *ngTemplateOutlet="PriceAgreementHistoryRows"></ng-container>
        }
        @case ('DispenserAgreementProductRows') {
          <ng-container *ngTemplateOutlet="DispenserAgreementProductRows"></ng-container>
        }
        @case ('SavedCartRow') {
          <ng-container *ngTemplateOutlet="SavedCartRow"></ng-container>
        }
        @case ('DispenserAgreementHistoryRow') {
          <ng-container *ngTemplateOutlet="DispenserAgreementHistoryRow"></ng-container>
        }
        @case ('ShipmentCreditClaimRow') {
          <ng-container *ngTemplateOutlet="ShipmentCreditClaimRow"></ng-container>
        }
        @case ('DispenserShipmentHistoryRow') {
          <ng-container *ngTemplateOutlet="DispenserShipmentHistoryRow"></ng-container>
        }
        @case ('RebateClaimsHistoryRow') {
          <ng-container *ngTemplateOutlet="RebateClaimsHistoryRow"></ng-container>
        }
        @case ('CreditClaimsHistoryRow') {
          <ng-container *ngTemplateOutlet="CreditClaimsHistoryRow"></ng-container>
        }
        @case ('ProductUpdatesRow') {
          <ng-container *ngTemplateOutlet="ProductUpdatesRow"></ng-container>
        }
        @default {
          <ng-container *ngTemplateOutlet="DefaultRows"></ng-container>
        }
      }
    }
  </div>

  @if (pagination && !showLoader) {
    <app-custom-pagination
      [pagination]="pagination"
      (changePage)="changePagination.emit($event)"
    ></app-custom-pagination>
  }

  @if (showLoader) {
    <div>
      <cx-spinner></cx-spinner>
    </div>
  }
</div>

<ng-template #HeaderButton let-header let-cssClass="cssClass">
  <div class="table-header-data table-header-button" [class]="cssClass" [style]="header.cssStyle">
    {{ header.translate ? (header.title | cxTranslate) : header.title }}
  </div>
</ng-template>

<ng-template #DefaultRows>
  @for (itemRow of rowSource; track itemRow) {
    <app-default-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-default-row>
  }
</ng-template>

<ng-template #PriceAgreementHistoryRows>
  @for (itemRow of rowSource; track itemRow) {
    <app-price-agreement-history-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-price-agreement-history-row>
  }
</ng-template>

<ng-template #DispenserAgreementProductRows>
  @for (itemRow of rowSource; track itemRow) {
    <app-dispenser-agreement-product-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      (changeEvent)="changeValue.emit($event)"
      [columns]="columnSource"
    ></app-dispenser-agreement-product-row>
  }
</ng-template>

<ng-template #SavedCartRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-saved-cart-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-saved-cart-row>
  }
</ng-template>

<ng-template #DispenserAgreementHistoryRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-dispenser-agreement-history-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-dispenser-agreement-history-row>
  }
</ng-template>

<ng-template #ShipmentCreditClaimRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-shipment-credit-claim-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-shipment-credit-claim-row>
  }
</ng-template>

<ng-template #DispenserShipmentHistoryRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-dispenser-shipment-history-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-dispenser-shipment-history-row>
  }
</ng-template>

<ng-template #RebateClaimsHistoryRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-rebate-claims-history-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-rebate-claims-history-row>
  }
</ng-template>

<ng-template #CreditClaimsHistoryRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-credit-claims-history-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-credit-claims-history-row>
  }
</ng-template>

<ng-template #ProductUpdatesRow>
  @for (itemRow of rowSource; track itemRow) {
    <app-product-updates-row
      class="table-row"
      [uid]="rowId"
      [row]="itemRow"
      [columns]="columnSource"
    ></app-product-updates-row>
  }
</ng-template>
